import React from 'react';
import type { ActivityPlugin } from '../../core/types/activity.types';
import { GAME_MODE_CATALOG } from '../../core/types/gameMode.types';
import {
  destacadoLogic,
  figuraLogic,
  formulaDestacadaLogic,
  glosarioTablaLogic,
  subtituloLogic,
} from './guide_editorial.logic';
import {
  DestacadoView,
  FiguraView,
  GlosarioTablaView,
  SubtituloView,
} from './GuideEditorialViews';
import { FormulaDestacadaActivityView } from './FormulaDestacada';

function makePlugin<M extends 'subtitulo' | 'destacado' | 'figura' | 'glosario_tabla' | 'formula_destacada'>(
  mode: M,
  logic: typeof subtituloLogic,
  View: React.ComponentType<{ payload: never }>,
): ActivityPlugin<M> {
  const meta = GAME_MODE_CATALOG[mode];
  return {
    ...logic,
    displayName: meta.displayName,
    icon: meta.icon,
    HostView: View,
    StudentView: View,
    ProjectorView: View,
  } as ActivityPlugin<M>;
}

export const subtituloPlugin = makePlugin('subtitulo', subtituloLogic, SubtituloView as never);
export const destacadoPlugin = makePlugin('destacado', destacadoLogic, DestacadoView as never);
export const figuraPlugin = makePlugin('figura', figuraLogic, FiguraView as never);
export const glosarioTablaPlugin = makePlugin(
  'glosario_tabla',
  glosarioTablaLogic,
  GlosarioTablaView as never,
);
export const formulaDestacadaPlugin = makePlugin(
  'formula_destacada',
  formulaDestacadaLogic,
  FormulaDestacadaActivityView as never,
);
